import { render, staticRenderFns } from "./WorkTicketTechniciansComponent.vue?vue&type=template&id=68c4deb1&scoped=true"
import script from "./WorkTicketTechniciansComponent.vue?vue&type=script&lang=js"
export * from "./WorkTicketTechniciansComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c4deb1",
  null
  
)

export default component.exports